var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 970,
    zoomAndPan: "magnify",
    viewBox: "0 0 727.5 299.999988",
    height: 400,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8f7e1266cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 614 226 L 655 226 L 655 266 L 614 266 Z M 614 226 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5717a860d9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 652.109375 265.953125 L 614.574219 228.417969 L 616.875 226.117188 L 654.410156 263.652344 Z M 652.109375 265.953125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "30aa7822f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 652.109375 265.953125 L 614.625 228.464844 L 616.867188 226.222656 L 654.355469 263.707031 Z M 652.109375 265.953125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f2959b3d83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 611.074219 222.246094 L 621.816406 222.246094 L 621.816406 232.988281 L 611.074219 232.988281 Z M 611.074219 222.246094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f91bb0d056"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 616.445312 222.246094 C 613.476562 222.246094 611.074219 224.652344 611.074219 227.617188 C 611.074219 230.582031 613.476562 232.988281 616.445312 232.988281 C 619.410156 232.988281 621.816406 230.582031 621.816406 227.617188 C 621.816406 224.652344 619.410156 222.246094 616.445312 222.246094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6b10c09d22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 611.074219 157.871094 L 621.816406 157.871094 L 621.816406 168.613281 L 611.074219 168.613281 Z M 611.074219 157.871094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b3b0b7ec7c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 616.445312 157.871094 C 613.476562 157.871094 611.074219 160.277344 611.074219 163.242188 C 611.074219 166.210938 613.476562 168.613281 616.445312 168.613281 C 619.410156 168.613281 621.816406 166.210938 621.816406 163.242188 C 621.816406 160.277344 619.410156 157.871094 616.445312 157.871094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b41775d099"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 520 254 L 647 254 L 647 299.894531 L 520 299.894531 Z M 520 254 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "055f81d550"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 644.144531 380.933594 L 520.109375 256.898438 L 522.410156 254.597656 L 646.445312 378.632812 Z M 644.144531 380.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f0209701ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 644.144531 380.933594 L 520.175781 256.960938 L 522.417969 254.71875 L 646.390625 378.6875 Z M 644.144531 380.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1ebfc52018"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 520 104 L 727 104 L 727 299.894531 L 520 299.894531 Z M 520 104 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f489b485e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 520.183594 321.3125 L 737.007812 104.488281 L 739.308594 106.789062 L 522.480469 323.613281 Z M 520.183594 321.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "660e022d63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 520.183594 321.3125 L 736.980469 104.515625 L 739.222656 106.757812 L 522.425781 323.558594 Z M 520.183594 321.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "09d493180f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 646.394531 258.171875 L 657.136719 258.171875 L 657.136719 268.917969 L 646.394531 268.917969 Z M 646.394531 258.171875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d2b2a2a0d7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 651.765625 258.171875 C 648.796875 258.171875 646.394531 260.578125 646.394531 263.546875 C 646.394531 266.511719 648.796875 268.917969 651.765625 268.917969 C 654.730469 268.917969 657.136719 266.511719 657.136719 263.546875 C 657.136719 260.578125 654.730469 258.171875 651.765625 258.171875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9eaa69d7c8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 614 160 L 727 160 L 727 299.894531 L 614 299.894531 Z M 614 160 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6156fdbebd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 786.113281 334.316406 L 614.597656 162.804688 L 616.898438 160.503906 L 788.410156 332.015625 Z M 786.113281 334.316406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3a1d5e72c4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 786.113281 334.316406 L 614.632812 162.835938 L 616.875 160.59375 L 788.355469 332.074219 Z M 786.113281 334.316406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2da884588e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 651 262 L 707 262 L 707 299.894531 L 651 299.894531 Z M 651 262 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 9.62915e+63
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 703.953125 317.519531 L 651.132812 264.699219 L 653.429688 262.398438 L 706.25 315.21875 Z M 703.953125 317.519531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "974355949b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 703.953125 317.519531 L 651.179688 264.75 L 653.425781 262.507812 L 706.195312 315.277344 Z M 703.953125 317.519531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c31efa9032"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 649 80 L 727 80 L 727 267 L 649 267 Z M 649 80 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "410aac366e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 649.851562 264.214844 L 833.132812 80.933594 L 835.433594 83.234375 L 652.152344 266.511719 Z M 649.851562 264.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f5bd2cfc19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 649.851562 264.214844 L 833.128906 80.941406 L 835.371094 83.183594 L 652.097656 266.457031 Z M 649.851562 264.214844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "02defbbe51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 468 161 L 619 161 L 619 299.894531 L 468 299.894531 Z M 468 161 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "efff12a283"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 468.898438 308.257812 L 615.996094 161.160156 L 618.296875 163.460938 L 471.199219 310.558594 Z M 468.898438 308.257812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d41d7f825d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 468.898438 308.257812 L 615.96875 161.191406 L 618.210938 163.433594 L 471.144531 310.5 Z M 468.898438 308.257812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d68a8536b1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 516.796875 251.640625 L 527.542969 251.640625 L 527.542969 262.382812 L 516.796875 262.382812 Z M 516.796875 251.640625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f3e07dc730"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 522.167969 251.640625 C 519.203125 251.640625 516.796875 254.042969 516.796875 257.011719 C 516.796875 259.976562 519.203125 262.382812 522.167969 262.382812 C 525.136719 262.382812 527.542969 259.976562 527.542969 257.011719 C 527.542969 254.042969 525.136719 251.640625 522.167969 251.640625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c13723b86e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 512 0.101562 L 685 0.101562 L 685 162 L 512 162 Z M 512 0.101562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "204f8b7373"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 682.394531 161.1875 L 512.914062 -8.296875 L 515.210938 -10.597656 L 684.695312 158.886719 Z M 682.394531 161.1875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "97bd86d1e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 682.394531 161.1875 L 512.949219 -8.257812 L 515.195312 -10.503906 L 684.640625 158.941406 Z M 682.394531 161.1875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "44b9621a4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 678.6875 155.074219 L 689.429688 155.074219 L 689.429688 165.816406 L 678.6875 165.816406 Z M 678.6875 155.074219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "838597563c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 684.058594 155.074219 C 681.09375 155.074219 678.6875 157.480469 678.6875 160.445312 C 678.6875 163.414062 681.09375 165.816406 684.058594 165.816406 C 687.027344 165.816406 689.429688 163.414062 689.429688 160.445312 C 689.429688 157.480469 687.027344 155.074219 684.058594 155.074219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "febd107f34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 615 0.101562 L 727 0.101562 L 727 93 L 615 93 Z M 615 0.101562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "20091b2d0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 615.230469 90.714844 L 832.054688 -126.113281 L 834.355469 -123.8125 L 617.527344 93.011719 Z M 615.230469 90.714844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "36dd7f1636"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 615.230469 90.714844 L 832.027344 -126.085938 L 834.273438 -123.84375 L 617.472656 92.957031 Z M 615.230469 90.714844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "410747c74d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 137 L 161 137 L 161 299.894531 L 0 299.894531 Z M 0 137 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9b46e04170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -58.894531 354.738281 L 157.929688 137.914062 L 160.230469 140.210938 L -56.59375 357.039062 Z M -58.894531 354.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "308b921a11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -58.894531 354.738281 L 157.90625 137.9375 L 160.148438 140.179688 L -56.652344 356.980469 Z M -58.894531 354.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5bcd63a8cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 140 L 161 140 L 161 299.894531 L 0 299.894531 Z M 0 140 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6e961926bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 157.902344 314.472656 L -13.609375 142.957031 L -11.308594 140.660156 L 160.203125 312.171875 Z M 157.902344 314.472656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "535ba44c8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 157.902344 314.472656 L -13.578125 142.992188 L -11.332031 140.746094 L 160.148438 312.226562 Z M 157.902344 314.472656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "153e5f8710"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 251 L 105 251 L 105 299.894531 L 0 299.894531 Z M 0 251 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "694d89d45a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -44.652344 398.699219 L 102.445312 251.601562 L 104.742188 253.902344 L -42.355469 401 Z M -44.652344 398.699219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a24396ec66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -44.652344 398.699219 L 102.414062 251.632812 L 104.65625 253.875 L -42.410156 400.945312 Z M -44.652344 398.699219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b47bf5b3c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 95.414062 250.105469 L 106.15625 250.105469 L 106.15625 260.851562 L 95.414062 260.851562 Z M 95.414062 250.105469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "47b843003f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 100.785156 250.105469 C 97.816406 250.105469 95.414062 252.511719 95.414062 255.480469 C 95.414062 258.445312 97.816406 260.851562 100.785156 260.851562 C 103.75 260.851562 106.15625 258.445312 106.15625 255.480469 C 106.15625 252.511719 103.75 250.105469 100.785156 250.105469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cf32804572"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.101562 L 136 0.101562 L 136 141 L 0 141 Z M 0 0.101562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "396bd8f7cf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -13.578125 138.507812 L 133.519531 -8.589844 L 135.820312 -6.292969 L -11.277344 140.804688 Z M -13.578125 138.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "679809e2d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -13.578125 138.507812 L 133.492188 -8.558594 L 135.734375 -6.316406 L -11.332031 140.75 Z M -13.578125 138.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3837c61793"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0.101562 L 161 0.101562 L 161 144 L 0 144 Z M 0 0.101562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f14c6554ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 157.898438 143.574219 L -0.0195312 -14.34375 L 2.28125 -16.644531 L 160.199219 141.273438 Z M 157.898438 143.574219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "53a9696b46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 157.898438 143.574219 L -0.00390625 -14.328125 L 2.238281 -16.574219 L 160.144531 141.332031 Z M 157.898438 143.574219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "66f34b6f7e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 104 L 125 104 L 125 299.894531 L 0 299.894531 Z M 0 104 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "791b59420f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -95.011719 321.3125 L 121.8125 104.488281 L 124.113281 106.789062 L -92.710938 323.613281 Z M -95.011719 321.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c194c8e089"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -95.011719 321.3125 L 121.789062 104.515625 L 124.03125 106.757812 L -92.769531 323.558594 Z M -95.011719 321.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "37e560010d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 151.351562 135.382812 L 162.097656 135.382812 L 162.097656 146.125 L 151.351562 146.125 Z M 151.351562 135.382812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5541f5dbd9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 156.726562 135.382812 C 153.757812 135.382812 151.351562 137.789062 151.351562 140.753906 C 151.351562 143.722656 153.757812 146.125 156.726562 146.125 C 159.691406 146.125 162.097656 143.722656 162.097656 140.753906 C 162.097656 137.789062 159.691406 135.382812 156.726562 135.382812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dfa81fe685"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.796875 100.648438 L 127.539062 100.648438 L 127.539062 111.390625 L 116.796875 111.390625 Z M 116.796875 100.648438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "77fa96449a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 122.167969 100.648438 C 119.199219 100.648438 116.796875 103.054688 116.796875 106.019531 C 116.796875 108.984375 119.199219 111.390625 122.167969 111.390625 C 125.132812 111.390625 127.539062 108.984375 127.539062 106.019531 C 127.539062 103.054688 125.132812 100.648438 122.167969 100.648438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7d5cfcc386"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 106 187 L 278 187 L 278 299.894531 L 106 299.894531 Z M 106 187 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "50db91d414"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 275.597656 359.332031 L 106.113281 189.847656 L 108.414062 187.546875 L 277.898438 357.03125 Z M 275.597656 359.332031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "91a3f1bf70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 275.597656 359.332031 L 106.152344 189.886719 L 108.394531 187.644531 L 277.839844 357.089844 Z M 275.597656 359.332031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c4913f4281"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 102.746094 184.613281 L 113.488281 184.613281 L 113.488281 195.359375 L 102.746094 195.359375 Z M 102.746094 184.613281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b9cd3cf131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 108.117188 184.613281 C 105.152344 184.613281 102.746094 187.019531 102.746094 189.984375 C 102.746094 192.953125 105.152344 195.359375 108.117188 195.359375 C 111.082031 195.359375 113.488281 192.953125 113.488281 189.984375 C 113.488281 187.019531 111.082031 184.613281 108.117188 184.613281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "011f985ef7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 611.074219 87.585938 L 621.816406 87.585938 L 621.816406 98.332031 L 611.074219 98.332031 Z M 611.074219 87.585938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c7d726d530"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 616.445312 87.585938 C 613.476562 87.585938 611.074219 89.992188 611.074219 92.957031 C 611.074219 95.925781 613.476562 98.332031 616.445312 98.332031 C 619.410156 98.332031 621.816406 95.925781 621.816406 92.957031 C 621.816406 89.992188 619.410156 87.585938 616.445312 87.585938 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8f7e1266cc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5717a860d9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#30aa7822f0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 652.109375 265.953125 L 614.644531 228.484375 L 616.875 226.253906 L 654.34375 263.71875 Z M 652.109375 265.953125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f2959b3d83)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f91bb0d056)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 611.074219 222.246094 L 621.816406 222.246094 L 621.816406 232.988281 L 611.074219 232.988281 Z M 611.074219 222.246094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6b10c09d22)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b3b0b7ec7c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7aa45",
    d: "M 611.074219 157.871094 L 621.816406 157.871094 L 621.816406 168.613281 L 611.074219 168.613281 Z M 611.074219 157.871094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b41775d099)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#055f81d550)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f0209701ad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7aa45",
    d: "M 644.144531 380.933594 L 520.175781 256.964844 L 522.410156 254.734375 L 646.378906 378.699219 Z M 644.144531 380.933594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1ebfc52018)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f489b485e0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#660e022d63)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 520.183594 321.3125 L 737.007812 104.488281 L 739.238281 106.71875 L 522.414062 323.546875 Z M 520.183594 321.3125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#09d493180f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d2b2a2a0d7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 646.394531 258.171875 L 657.136719 258.171875 L 657.136719 268.917969 L 646.394531 268.917969 Z M 646.394531 258.171875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9eaa69d7c8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6156fdbebd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3a1d5e72c4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7aa45",
    d: "M 786.113281 334.316406 L 614.597656 162.804688 L 616.832031 160.570312 L 788.34375 332.085938 Z M 786.113281 334.316406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2da884588e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9629150e57)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#974355949b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 703.953125 317.519531 L 651.199219 264.765625 L 653.429688 262.535156 L 706.183594 315.289062 Z M 703.953125 317.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c31efa9032)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#410aac366e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f5bd2cfc19)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 649.851562 264.214844 L 833.132812 80.933594 L 835.367188 83.164062 L 652.085938 266.445312 Z M 649.851562 264.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#02defbbe51)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#efff12a283)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d41d7f825d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7aa45",
    d: "M 468.898438 308.257812 L 615.996094 161.160156 L 618.230469 163.390625 L 471.132812 310.488281 Z M 468.898438 308.257812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d68a8536b1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f3e07dc730)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7aa45",
    d: "M 516.796875 251.640625 L 527.542969 251.640625 L 527.542969 262.382812 L 516.796875 262.382812 Z M 516.796875 251.640625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c13723b86e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#204f8b7373)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#97bd86d1e8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 682.394531 161.1875 L 512.980469 -8.230469 L 515.210938 -10.460938 L 684.628906 158.953125 Z M 682.394531 161.1875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#44b9621a4f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#838597563c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 678.6875 155.074219 L 689.429688 155.074219 L 689.429688 165.816406 L 678.6875 165.816406 Z M 678.6875 155.074219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#febd107f34)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#20091b2d0d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#36dd7f1636)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 615.230469 90.714844 L 832.054688 -126.113281 L 834.285156 -123.878906 L 617.460938 92.945312 Z M 615.230469 90.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#410747c74d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9b46e04170)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#308b921a11)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M -58.894531 354.738281 L 157.933594 137.914062 L 160.164062 140.144531 L -56.660156 356.96875 Z M -58.894531 354.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5bcd63a8cc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6e961926bd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#535ba44c8b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7aa45",
    d: "M 157.902344 314.472656 L -13.609375 142.957031 L -11.378906 140.726562 L 160.136719 312.238281 Z M 157.902344 314.472656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#153e5f8710)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#694d89d45a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a24396ec66)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7aa45",
    d: "M -44.652344 398.699219 L 102.445312 251.601562 L 104.675781 253.835938 L -42.421875 400.933594 Z M -44.652344 398.699219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b47bf5b3c0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#47b843003f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7aa45",
    d: "M 95.414062 250.105469 L 106.15625 250.105469 L 106.15625 260.851562 L 95.414062 260.851562 Z M 95.414062 250.105469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf32804572)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#396bd8f7cf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#679809e2d1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7aa45",
    d: "M -13.578125 138.507812 L 133.519531 -8.589844 L 135.753906 -6.359375 L -11.34375 140.738281 Z M -13.578125 138.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3837c61793)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f14c6554ba)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#53a9696b46)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 157.898438 143.574219 L -0.0195312 -14.34375 L 2.210938 -16.578125 L 160.132812 141.34375 Z M 157.898438 143.574219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#66f34b6f7e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#791b59420f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c194c8e089)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M -95.011719 321.3125 L 121.8125 104.488281 L 124.046875 106.71875 L -92.78125 323.546875 Z M -95.011719 321.3125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#37e560010d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5541f5dbd9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 151.351562 135.382812 L 162.097656 135.382812 L 162.097656 146.125 L 151.351562 146.125 Z M 151.351562 135.382812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dfa81fe685)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#77fa96449a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 116.796875 100.648438 L 127.539062 100.648438 L 127.539062 111.390625 L 116.796875 111.390625 Z M 116.796875 100.648438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7d5cfcc386)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#50db91d414)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#91a3f1bf70)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 275.597656 359.332031 L 106.179688 189.914062 L 108.414062 187.683594 L 277.828125 357.101562 Z M 275.597656 359.332031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c4913f4281)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b9cd3cf131)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 102.746094 184.613281 L 113.488281 184.613281 L 113.488281 195.359375 L 102.746094 195.359375 Z M 102.746094 184.613281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#011f985ef7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c7d726d530)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1939",
    d: "M 611.074219 87.585938 L 621.816406 87.585938 L 621.816406 98.332031 L 611.074219 98.332031 Z M 611.074219 87.585938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBanner);
export default __webpack_public_path__ + "static/media/contact_banner.9e1cb8b2a2a99d16eb92a8e729b5ce8e.svg";
export { ForwardRef as ReactComponent };